module.exports = __webpack_public_path__ + "1fb38e62bd22235a2e83e9a39f6f4d45.png";